const MODAL_CLOSE_X = 'Base Modal X Button Icon'

module.exports = {
    MODAL_CLOSE_X
}